<template lang="pug">
#referral-rebate.tab-pane.fade.show.active
  .statement-wrapper
    .statement-mobile
      .statement-single
        template(v-if="rebateList.length > 0")
          .statement-single-content(v-for="data in rebateList")        
            .statement-date.redeem
              .text-capitalize {{$t('ui.date')}}
              div {{ $moment(data.created_date).format("YYYY-MM-DD") }}
            .statement-detail
              .statement-detail-left {{$t('ui.referee')}}
              .statement-detail-right {{data.referee_id}}
            .statement-detail
              .statement-detail-left {{$t('ui.amount')}}
              .statement-detail-right {{data.amount}}
        template(v-else)
          .text-center.my-2 {{ $t('ui.no_record') }}
    .statement-desktop
      .table-statement
        .row.table-statement-row
          .col.table-statement-col {{$t('ui.date')}}
          .col.table-statement-col {{$t('ui.referee')}}
          .col.table-statement-col {{$t('ui.amount')}}
        template(v-if="rebateList.length > 0")
          .row.table-statement-row(v-for="data in rebateList")
            .col.table-statement-col {{ $moment(data.created_date).format("YYYY-MM-DD") }}
            .col.table-statement-col {{data.referee_id}}
            .col.table-statement-col {{data.amount}}
        template(v-else)
          .text-center.my-2 {{ $t('ui.no_record') }}
</template>
<script>
export default {
  data(){
    return{
      rebateList:[],
      totalRebate:0,
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        
      }else{
        vm.getReferralRebateList()
      }
    }
  },
  mounted(){
    this.getReferralRebateList()
  },
  methods:{
    getReferralRebateList(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getReferralRebateList", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.rebateList =  response.data
              if(this.rebateList.length > 0){
                for(var i = 0; i<this.rebateList.length; i++){
                  this.totalRebate += this.rebateList[i].amount
                }
                
              }
              this.$emit("totalReferral", this.totalRebate)
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    }
  }
}
</script>